import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild, inject } from '@angular/core';
import { Review } from '@df/catalog/review/review';
import { DfImageWrapperComponent } from '@df/module-image/df-image-wrapper.component';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { ImageModule } from '@df/module-image/image.module';
import { RatingComponent } from '@df/ui/common/rating.component';
import { DfUiModule } from '@df/ui/df-ui.module';
import { FormatDatePipe } from '@df/ui/display/format-date.pipe';
import { PhotoswipeLightboxComponent } from '@df/ui/photoswipe/photoswipe-lightbox.component';
import { PhotoswipeDirective } from '@df/ui/photoswipe/photoswipe.directive';
import { PhotoswipeService } from '@df/ui/photoswipe/photoswipe.service';
import { PhotoswipeUiDefaultOptions } from '@df/ui/photoswipe/photoswipe.types';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { ReadMoreComponent } from '../../../display/read-more/read-more.component';
declare module '@df/catalog/review/review' {
    interface IReviewData {
        images: {
            url: string;
            feefo_media_id: string;
        }[];
    }
}
@Component({
    selector: 'product-reviews-item',
    templateUrl: './product-reviews-item.html',
    styleUrls: ['./product-reviews-item.scss'],
    standalone: true,
    imports: [
        DfUiModule,
        RatingComponent,
        NgClass,
        FormatDatePipe,
        ImageModule,
        ReadMoreComponent,
        PhotoswipeLightboxComponent,
        PhotoswipeDirective,
        TranslatePipe,
        NgTemplateOutlet,
        DfImageDirective,
        DfImageWrapperComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: PhotoswipeService,
            useClass: PhotoswipeService
        }
    ]
})
export class ProductReviewsItemComponent extends UiComponent implements OnInit, OnDestroy {
    @Input({
        required: true
    })
    review!: Review;
    @Input()
    variant: 'standard' | 'modal' = 'standard';
    @ViewChild(PhotoswipeLightboxComponent, { read: ElementRef, static: false })
    protected photoswipeLightboxComponent?: ElementRef<HTMLElement>;

    private renderer2 = inject(Renderer2);

    photoswipeOptions: Partial<PhotoswipeUiDefaultOptions> = {};
    /**
     * @depreciated Please use asyncCd (typo)
     */
    protected acyncCd = false;
    override ngOnInit(): void {
        super.ngOnInit();
        const photoswipeLightboxComponent = this.photoswipeLightboxComponent;
        if (photoswipeLightboxComponent) {
            this.photoswipeOptions = {
                showAnimationDuration: 250,
                hideAnimationDuration: 250,
                pinchToClose: false,
                clickToCloseNonZoomable: false,
                closeOnScroll: false,
                closeOnVerticalDrag: false,
                tapToToggleControls: false,
                hiddenControlsMobile: false,
                counterEl: false,
                barsSize: { top: 0, bottom: 'auto' },
                initialZoom: 1,
                followMouse: true,
                canPreload: false,
                timeToIdle: 0,
                getDoubleTapZoom: (isMouseClick, item: any) => {
                    if (!item.zoomLevel) {
                        item.zoomLevel = item.initialZoomLevel;
                    }
                    let res: number;
                    if (item.zoomLevel < 0.5 && (this.client.isM || this.client.isS)) {
                        res = 0.5;
                        this.renderer2.addClass(photoswipeLightboxComponent.nativeElement, 'photoswipe--zoom-50');
                        this.renderer2.removeClass(photoswipeLightboxComponent.nativeElement, 'photoswipe--zoom-100');
                    } else if (item.zoomLevel < 1) {
                        res = 1;
                        this.renderer2.addClass(photoswipeLightboxComponent.nativeElement, 'photoswipe--zoom-100');
                        this.renderer2.removeClass(photoswipeLightboxComponent.nativeElement, 'photoswipe--zoom-50');
                    } else {
                        res = item.initialZoomLevel;
                        this.renderer2.removeClass(photoswipeLightboxComponent.nativeElement, 'photoswipe--zoom-50');
                        this.renderer2.removeClass(photoswipeLightboxComponent.nativeElement, 'photoswipe--zoom-100');
                    }
                    item.zoomLevel = res;
                    return res;
                }
            };
            const root = this.client.getRootElement();
            root.appendChild(photoswipeLightboxComponent.nativeElement);
            this.detectChanges();
        }
    }
    override ngOnDestroy(): void {
        if (this.photoswipeLightboxComponent) {
            const root = this.client.getRootElement();
            root.removeChild(this.photoswipeLightboxComponent.nativeElement);
        }
        super.ngOnDestroy();
    }
}
